<script setup>
import { computed, onMounted, ref } from 'vue';
import { useStore } from 'vuex';

import AuditTrails from 'next/wgpt/AuditTrail/AuditTrails.vue';

const props = defineProps({
  card: {
    type: Object,
    required: true,
  },
});

const store = useStore();
const relativeIds = ref(null);

const auditTrailFilters = computed(() => {
  const filters = [
    {
      attributeKey: 'model',
      filterOperator: 'equal_to',
      values: {
        id: 'WgptBoardListCard',
        name: 'WgptBoardListCard',
      },
      queryOperator: 'and',
      attributeModel: 'standard',
    },
    {
      attributeKey: 'id',
      filterOperator: 'equal_to',
      values: props.card.originalId,
      queryOperator: 'or',
      attributeModel: 'standard',
    },
  ];

  (relativeIds.value?.activity_ids || []).forEach(id => {
    filters.push(
      {
        attributeKey: 'model',
        filterOperator: 'equal_to',
        values: {
          id: 'WgptBoardListCardActivity',
          name: 'WgptBoardListCardActivity',
        },
        queryOperator: 'and',
        attributeModel: 'standard',
      },
      {
        attributeKey: 'id',
        filterOperator: 'equal_to',
        values: id,
        queryOperator: 'or',
        attributeModel: 'standard',
      }
    );
  });

  return filters;
});

onMounted(async () => {
  relativeIds.value = await store.dispatch(
    'wgptBoardListCards/getRelativeIds',
    {
      boardId: props.card.boardId,
      listId: props.card.listId,
      cardId: props.card.id,
    }
  );
});
</script>

<template>
  <AuditTrails v-if="relativeIds" :filters="auditTrailFilters" />
</template>
